import PropTypes from 'prop-types'

import {createQantasMembership} from '../../../api'
import BusinessConnectionDrawer from '../BusinessConnectionDrawer'

import useFetchPrepopulationData from './hooks/useFetchPrepopulationData'
import {getValidationSchema} from './schema'
import FormComponent from './FormComponent'
import TermsAndConditionsModal from './TermsAndConditionsModal'

const QantasBusinessConnectionDrawer = ({
  isOpen,
  onClose,
  partner,
  onSuccess,
}) => {
  return (
    <BusinessConnectionDrawer
      isOpen={isOpen}
      onClose={onClose}
      partner={partner}
      onSuccess={onSuccess}
      apiFunction={createQantasMembership}
      FormComponent={FormComponent}
      useFetchPrepopulationData={useFetchPrepopulationData}
      getValidationSchema={getValidationSchema}
      TermsAndConditionsModal={TermsAndConditionsModal}
    />
  )
}

QantasBusinessConnectionDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  partner: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    name: PropTypes.string.isRequired,
    key: PropTypes.string.isRequired,
  }),
  onSuccess: PropTypes.func.isRequired,
}

QantasBusinessConnectionDrawer.defaultProps = {
  partner: null,
}

export default QantasBusinessConnectionDrawer
